import { Box, Image } from '@chakra-ui/react';
import {
  HStack,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Button } from 'components/ui/button';

const chevronRight = '../chevron-right.png';
const chevronLeft = '../chevron-left.png';

type Props = {
  activeScreenIdx: number;
  title?: string;
  section?: string;
  phase?: string;
  numScreens?: number;
  prevScreen: () => void;
  nextScreen: () => void;
};

const PreviewHeader = ({
  activeScreenIdx,
  section,
  phase,
  title,
  numScreens = 0,
  prevScreen,
  nextScreen,
}: Props) => {
  return (
    <VStack
      mb={'auto'}
      mt={0}
      backgroundColor={'warmGray.300'}
      p={2}
    >
      <Box>
        {title && (
          <Text my={1} w={'100%'}>
            <Text fontWeight={'bold'}>{'Title: '}</Text>
            <Text>{title}</Text>
          </Text>
        )}
        <Text my={1} w={'100%'}>
          <Text fontWeight={'bold'}>{'Section: '}</Text>
          <Text>{section}</Text>
        </Text>
        {phase && (
          <Text my={1} w={'100%'}>
            <Text fontWeight={'bold'}>{'Phase: '}</Text>
            <Text>{phase}</Text>
          </Text>
        )}
        <Text my={1} w={'100%'}>
          <Text fontWeight={'bold'}>{'Screen: '}</Text>
          <Text>{`${activeScreenIdx + 1} of ${numScreens}`}</Text>
        </Text>
      </Box>
      <HStack>
        <Button
          mr={2}
          backgroundColor={'amber.100'}
          onClick={prevScreen}
          disabled={activeScreenIdx === 0}
        >
          <Image boxSize={'32px'} src={chevronLeft} />
        </Button>
        <Button
          backgroundColor={'amber.100'}
          onClick={nextScreen}
          disabled={activeScreenIdx === numScreens - 1}
        >
          <Image boxSize={'32px'} src={chevronRight} />
        </Button>
      </HStack>
    </VStack>
  );
};

export default PreviewHeader;
